import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import * as Sentry from '@sentry/react';

import {
  BUILD_COMMIT_HASH,
  IS_E2E_TEST,
  sentryNoiseFilters,
  sentryReactIntegrations,
  suppressResizeObserverLoopError,
} from '@spotify/confidence-core-react';

import { confidenceApi } from './apis/Apis';
import { loadTrackJS } from './apis/ConsentManagement';
import { setupConfidenceTrackers } from './confidenceTrackers';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const IS_LOCALHOST = window?.location.hostname.startsWith('localhost');

if (IS_PRODUCTION && !IS_E2E_TEST && !IS_LOCALHOST) {
  loadTrackJS();
}

if (IS_PRODUCTION && !IS_E2E_TEST) {
  setupConfidenceTrackers(confidenceApi);
}

Sentry.init({
  dsn: 'https://e429b0654e22474f81655df4103dd4bb@o22381.ingest.sentry.io/4504633286131712',
  release: `confidence@${BUILD_COMMIT_HASH}`,
  tracesSampleRate: 0.0025,
  enabled: IS_PRODUCTION && !IS_LOCALHOST,
  environment: process.env.NODE_ENV,
  integrations: sentryReactIntegrations(),
  ...sentryNoiseFilters,
});

if (!IS_PRODUCTION) {
  suppressResizeObserverLoopError();

  // show apollo errors in dev
  loadDevMessages();
  loadErrorMessages();

  import('@spotify/confidence-dev-instrumentation/msw').then(({ initMsw }) =>
    initMsw(() => import('./mocks/browser')),
  );
}
